/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Offline_TitleInputs */

const en_recipe_offline_title = /** @type {(inputs: Recipe_Offline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not available offline`)
};

const de_recipe_offline_title = /** @type {(inputs: Recipe_Offline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline nicht verfügbar`)
};

/**
* | output |
* | --- |
* | "Not available offline" |
*
* @param {Recipe_Offline_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_offline_title = /** @type {((inputs?: Recipe_Offline_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Offline_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_offline_title(inputs)
	return en_recipe_offline_title(inputs)
});